import { Image } from "./image";
import React from "react";

export const Gallery = (props) => {
  return (
    <>
      <style>{`
        #portfolio {
          overflow-x: hidden;
          width: 100%;
          box-sizing: border-box;
        }
        #portfolio .container {
          width: 100%;
          max-width: 1170px;
          margin: 0 auto;
          padding: 0 15px;
          box-sizing: border-box;
        }
        #portfolio .portfolio-items {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 10px;
          box-sizing: border-box;
        }

        /* Fixed uniform size for all gallery images */
        #portfolio .portfolio-items .portfolio-item-wrapper {
          width: 100%;
          aspect-ratio: 4 / 3;
          overflow: hidden;
          border-radius: 4px;
        }
        #portfolio .portfolio-items .portfolio-item-wrapper img,
        #portfolio .portfolio-items .portfolio-item-wrapper a img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
          transition: transform 0.3s ease;
        }
        #portfolio .portfolio-items .portfolio-item-wrapper a {
          display: block;
          width: 100%;
          height: 100%;
        }
        #portfolio .portfolio-items .portfolio-item-wrapper:hover img,
        #portfolio .portfolio-items .portfolio-item-wrapper:hover a img {
          transform: scale(1.05);
        }

        /* Mobile: keep 3 columns but reduce gap */
        @media (max-width: 767px) {
          #portfolio .portfolio-items {
            gap: 6px;
          }
          #portfolio .container {
            padding: 0 8px;
          }
        }
      `}</style>

      <div id="portfolio" className="text-center">
        <div className="container">
          <div className="section-title">
            <h2>Gallery</h2>
            <p>
             
            </p>
          </div>
          <div className="row">
            <div className="portfolio-items">
              {props.data
                ? props.data.map((d, i) => (
                    <div key={`${d.title}-${i}`}>
                      <div className="portfolio-item-wrapper">
                        <Image
                          title={d.title}
                          largeImage={d.largeImage}
                          smallImage={d.smallImage}
                        />
                      </div>
                    </div>
                  ))
                : "Loading..."}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};